import { render, staticRenderFns } from "./infoStatement.vue?vue&type=template&id=4e75c759&"
import script from "./infoStatement.vue?vue&type=script&lang=js&"
export * from "./infoStatement.vue?vue&type=script&lang=js&"
import style0 from "./infoStatement.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports